/**
 * TripMetricsBar — bottom summary metrics row on trip detail overview.
 */
import styled from "styled-components";
import {
  formatCurrencyZAR,
  formatRiskStatusLabel,
  getRiskStatusTone,
} from "../utils/tripFormatters.js";

const Bar = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Metric = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 16px;
  text-align: center;
`;

const Value = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: ${({ $tone }) => {
    if ($tone === "danger") return "#dc2626";
    if ($tone === "warning") return "#d97706";
    if ($tone === "success") return "#059669";
    return "#111827";
  }};
  line-height: 1.2;
`;

const Label = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: #64748b;
`;

const TripMetricsBar = ({
  ordersCount = 0,
  dropsCount = 0,
  capacityUsedM3 = 0,
  estimatedRevenue = 0,
  riskSummary = null,
}) => {
  const riskLabel = formatRiskStatusLabel(riskSummary);
  const riskTone = getRiskStatusTone(riskSummary);

  return (
    <Bar data-testid="trip-metrics-bar">
      <Metric>
        <Value>{ordersCount}</Value>
        <Label>Orders</Label>
      </Metric>
      <Metric>
        <Value>{dropsCount}</Value>
        <Label>Drops</Label>
      </Metric>
      <Metric>
        <Value>{Number(capacityUsedM3).toFixed(0)} m³</Value>
        <Label>Capacity Used</Label>
      </Metric>
      <Metric>
        <Value>{formatCurrencyZAR(estimatedRevenue)}</Value>
        <Label>Est. Revenue</Label>
      </Metric>
      <Metric>
        <Value $tone={riskTone}>{riskLabel}</Value>
        <Label>Risk Status</Label>
      </Metric>
    </Bar>
  );
};

export default TripMetricsBar;
